
import React, { useState } from 'react';
import { Fragment } from "react"
import { Helmet } from 'react-helmet';
import { useRouteMatch } from "react-router";
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import '../blogs.module.css'
import EditBlogButton from './EditButton';
import MultiSelectDropdown from '../../shared/Multiselect';
import FlexFooter from '../../Layout/FlexFooter';
import { faImage } from '@fortawesome/pro-solid-svg-icons';
import PreselectedImages from '../../shared/ImageInput/PreselectedImages';
import { autzuLocations, selectedSrc } from '../../../utils';

const EditBlogContent = ({blog}) => {

    const match = useRouteMatch();
    const region = match.params.region;
    
    const cities = blog.cities.map(city => city.name);

    const [title,setTitle] = useState(blog.title);
    const [content,setContent] = useState(blog.content);
    const [image, setImage] = useState(blog.imageUrl);
    const [locations, setLocations] = useState(cities);
    const [preselected, setPreselected] = useState(false);


    const handleTitleChange = (event) => {
        setTitle(event.target.value);
    };

    const handleContentChange = (event) => {
        setContent(event.target.value);
    };

    const togglePreselected = () => {
        setPreselected(!preselected);
    }

    const displayImage = () => {
        if (!image)
        {
            return {display:'none'}
        }
        else return {}
    }

    const mutationImage = (image) => {
        if (image.name || image.src){
            return image
        }
        else {
            return null
        }
    }


    return(
        <Fragment>
            <Helmet>
                <title>Edit Blog</title>
            </Helmet>
            <div className='blogsPage container'>
                <div className='editBlogsContainer'>
                    <div className='editBlogsTitle'>Edit Blog</div>

                    <div className='fieldLabel'>Locations</div>
                    <MultiSelectDropdown options={autzuLocations} selectedOptions={locations} setSelectedOptions={setLocations} allOptions={"All locations"}/>
                    
                    <div className='fieldLabel'>Blog Title</div>
                    <input className='editTitle' value={title} onChange={handleTitleChange}/>
                    <div className='fieldFooter'>Title must be unique</div>

                    <div className='fieldLabel'>Image</div>
                    <div className='uploadSection'>
                        <img className='uploadImage' src={selectedSrc(image)} style={displayImage()}/>
                        <div className='selectButton' onClick={togglePreselected}><FontAwesomeIcon icon={faImage}/>Select Image</div>
                    </div>

                    <PreselectedImages open={preselected} toggle={togglePreselected} text="Image" file={image} setFile={setImage}/>
                    <div className='fieldLabel' >Blog Content</div>
                    <textarea className='editContent' value={content} onChange={handleContentChange}/>

                    <EditBlogButton id={Number(blog.id)} title={title} content={content} image={mutationImage(image)} locations={locations} urlTitle={blog.urlTitle}/>

                </div>
            <FlexFooter region={region}/>
            </div>
        </Fragment>
    )
}

export default EditBlogContent;


// WEBPACK FOOTER //
// ./src/components/Blogs/EditBlog/EditBlogContent.js